import React, { useState, useEffect, useMemo } from 'react';
import { Footer, Header } from './headerFooter';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { getHost } from './config';
import FilterSidebar from './FilterSidebar';
import { initialSidebarOpen, collapseFilterSidebarOnMobile, joinFilterSummaryParts } from './filterSidebarUtils';
import './custom.scss';
import { EDU_SPECIALTIES_APPOINTMENTS } from './constants';




function HistoricalDataAppointments() {

    const navigate = useNavigate();
    const [yearRange, setYearRange] = useState('');
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const [specialty, setSpecialty] = useState('');
    const [data, setData] = useState(null);
    const [uniqueDates, setUniqueDates] = useState([]);
    const [uniqueLocations, setUniqueLocations] = useState([]);
    const [eidikiAgogi, setEidikiAgogi] = useState(false);
    const [loading, setLoading] = useState(false); // New loading state
    const [sidebarOpen, setSidebarOpen] = useState(initialSidebarOpen);
    const token = localStorage.getItem('authToken');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [token, navigate]);

    const handleLogout = () => {
        // Clear the authToken from localStorage
        localStorage.removeItem('authToken');
        localStorage.setItem('logout-event', Date.now());

        // Redirect to the login page
        navigate('/', { replace: true });
    }


    const handleSubmit = () => {
        setLoading(true);
        const url = `${getHost()}/api/historical-data-appointments`;
        const requestBody = {
            specialty: specialty,
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(requestBody),
        })
            .then(response => response.json())
            .then(data => {
                setData(data.results);
                const dates = new Set()
                const locations = new Set();
                data.results.forEach((item) => {
                    dates.add(item.date);
                    Object.keys(item.locations).forEach(location => {
                        locations.add(location);
                    });
                });
                setUniqueDates(Array.from(dates));
                setUniqueLocations(
                    Array.from(locations)
                        .sort((a, b) => {
                            if (a === "Σύνολο") return 1;
                            if (b === "Σύνολο") return -1;
                            return a.localeCompare(b, "el"); // Optional: sort Greek strings properly
                        })
                );
                collapseFilterSidebarOnMobile(setSidebarOpen);
            })
            .catch(error => console.error('Error fetching data:', error))
            .finally(() => {
                setLoading(false); // Hide loading indicator regardless of success/failure
            });
    };

    
    const isFormValid = specialty !== '';

    const filterSummary = useMemo(
        () => joinFilterSummaryParts([specialty]),
        [specialty]
    );

    return (
        <div id="root">
            <Header handleLogout={handleLogout}/>
            <main className='main-container ranking-per-state-page'>
                <FilterSidebar
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                    filterSummary={filterSummary}
                    bodyId="historical-data-appointments-sidebar-body"
                >
                        <Form>
                            <Form.Group className="mb-3 pt-3" controlId="registerForm.specialty">
                                <Form.Label className='custom-label'>Ειδικότητα</Form.Label>
                                <Form.Select className="custom-form" name="specialty" value={specialty} onChange={(e) => setSpecialty(e.target.value)} required>
                                    <option value="">Επιλέξτε ειδικότητα</option>
                                    {EDU_SPECIALTIES_APPOINTMENTS.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Form>
                        <div className="d-flex justify-content-center mt-3">
                            <Button
                                variant="secondary"
                                type="button"
                                className="predict-submit-button"
                                onClick={handleSubmit}
                                disabled={!isFormValid}
                            >
                                Υποβολή
                            </Button>
                        </div>
                </FilterSidebar>
                <div className={`ranking-per-state-main ${!sidebarOpen ? 'ranking-per-state-main--sidebar-collapsed' : ''}`}>
                    <Container fluid className="ranking-per-state-container">
                        <Row className="g-3 g-md-4">
                            <Col xs={12}>
                                <div className="ranking-per-state-content">
                                {!data && !loading && (
                                    <p className="text-muted small mb-2">
                                        Ιστορικά δεδομένα διορισμών προηγούμενων ετών ανά έτος διορισμού και ανά περιοχή ειδικότητα και περιοχή.
                                    </p>
                                )}
                                {loading && (
                                        <div className="text-center mt-3 mb-3">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <div>Φόρτωση αποτελεσμάτων...</div>
                                        </div>
                                    )}

                                    {data ? (
                                        <div className={!sidebarOpen ? 'results-snug-mobile' : ''}>
                                            <div className="d-flex align-items-center my-3">
                                                <h5 className="text-center flex-grow-1 m-0">Αποτελέσματα</h5>
                                            </div>
                                            <div className='table-outer-wrapper'>
                                                <div className="table-scroll-wrapper">
                                                    <Table bordered className="historical-results-table">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                {uniqueDates.map(date => (
                                                                    <th key={date}>{date}</th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {uniqueLocations.map(place => (
                                                                <tr key={place} className="cell-wrap">
                                                                    <td>{place}</td>
                                                                    {uniqueDates.map(date => (
                                                                        <td key={date}>
                                                                            {
                                                                                data.find(item => item.date === date)?.locations[place] || 0
                                                                            }
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                    ) : !loading && null}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </main>

            <Footer />
        </div>
    );

}

export default HistoricalDataAppointments;